import React, { useState, createContext, useContext } from 'react';
export type Lang = 'UA' | 'RU' | 'EN';
interface LanguageContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
}
const LanguageContext = createContext<LanguageContextValue>({
  lang: 'UA',
  setLang: () => {}
});
function getInitialLang(): Lang {
  try {
    const stored = localStorage.getItem('esca_lang');
    if (stored === 'UA' || stored === 'RU' || stored === 'EN') return stored;
  } catch {}
  return 'UA';
}
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>(getInitialLang);
  const setLang = (newLang: Lang) => {
    setLangState(newLang);
    try {
      localStorage.setItem('esca_lang', newLang);
    } catch {}
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang
  }} data-id="element-1220" data-mp="2xumvsq33ft0a">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}